import api from './api';

const restaurantService = {
  getMyRestaurants: async () => {
    const response = await api.get('/restaurants/partner/mine');
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/restaurants/stats');
    return response.data;
  },

  getAll: async (params = {}) => {
    const response = await api.get('/restaurants', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/restaurants/${id}`);
    return response.data;
  },

  getMenu: async (id) => {
    const response = await api.get(`/restaurants/${id}/menu`);
    return response.data;
  },

  // ── Menu item options (Uber-Eats style) ───────────────────────────────────
  createOptionGroup: async (itemId, payload) => {
    const response = await api.post(`/restaurants/menu-items/${itemId}/option-groups`, payload);
    return response.data;
  },
  updateOptionGroup: async (groupId, payload) => {
    const response = await api.put(`/restaurants/option-groups/${groupId}`, payload);
    return response.data;
  },
  deleteOptionGroup: async (groupId) => {
    const response = await api.delete(`/restaurants/option-groups/${groupId}`);
    return response.data;
  },
  createOptionChoice: async (groupId, payload) => {
    const response = await api.post(`/restaurants/option-groups/${groupId}/choices`, payload);
    return response.data;
  },
  updateOptionChoice: async (choiceId, payload) => {
    const response = await api.put(`/restaurants/option-choices/${choiceId}`, payload);
    return response.data;
  },
  deleteOptionChoice: async (choiceId) => {
    const response = await api.delete(`/restaurants/option-choices/${choiceId}`);
    return response.data;
  },

  toggleOptionChoice: async (choiceId) => {
    const response = await api.patch(`/restaurants/option-choices/${choiceId}/toggle`);
    return response.data;
  },

  createPaymentIntent: async (data) => {
    const response = await api.post('/restaurants/orders/create-payment-intent', data);
    return response.data;
  },

  createOrder: async (orderData) => {
    const response = await api.post('/restaurants/orders', orderData);
    return response.data;
  },

  getMyOrders: async () => {
    const response = await api.get('/restaurants/orders/my-orders');
    return response.data;
  },

  getOrder: async (id) => {
    const response = await api.get(`/restaurants/orders/${id}`);
    return response.data;
  },

  updateOrderStatus: async (id, status) => {
    const response = await api.put(`/restaurants/orders/${id}/status`, { status });
    return response.data;
  },

  verifyDeliveryCode: async (orderId, code) => {
    const response = await api.post(`/restaurants/orders/${orderId}/verify-delivery`, { code });
    return response.data;
  },

  // ── Driver ──────────────────────────────────────────────────────────────────
  acceptDelivery: async (orderId) => {
    const response = await api.post(`/restaurants/orders/${orderId}/accept-delivery`);
    return response.data;
  },

  refuseDelivery: async (orderId) => {
    const response = await api.post(`/restaurants/orders/${orderId}/refuse-delivery`);
    return response.data;
  },

  toggleDriverDuty: async (is_on_duty) => {
    const response = await api.put('/restaurants/driver/duty', { is_on_duty });
    return response.data;
  },

  updateDriverLocation: async (latitude, longitude) => {
    const response = await api.put('/restaurants/driver/location', { latitude, longitude });
    return response.data;
  },

  getDriverActiveOrder: async () => {
    const response = await api.get('/restaurants/driver/active');
    return response.data;
  },

  getDriverStats: async () => {
    const response = await api.get('/restaurants/driver/stats');
    return response.data;
  },

  getDriverPendingOffer: async () => {
    const response = await api.get('/restaurants/driver/pending-offer');
    return response.data;
  },

  validatePromo: async (payload) => {
    return await api.post('/restaurants/promo/validate', payload);
  },
};

export default restaurantService;
